module.exports = __webpack_public_path__ + "img/marketing.290c297f.png";